import { PageAgentExecution } from '~/features/ask-anything/agentic-ai/types';
import {
  ListAgentExecutionsApiV1AgentExecutionsGetApiArg,
  ListAgentExecutionsApiV1AgentExecutionsGetApiResponse,
} from '~/redux/api/types/sylvanus/agentExecution';
import { sylvanus } from '~/services/serviceInstances';

import { mapServerAgentExecutionToAgentExecution } from './transformers';

export const getAgentExecutions = async (
  params: ListAgentExecutionsApiV1AgentExecutionsGetApiArg,
): Promise<PageAgentExecution> => {
  const response =
    await sylvanus.get<ListAgentExecutionsApiV1AgentExecutionsGetApiResponse>(
      '/agent-executions',
      {
        params: {
          entity_type: params.entityType,
          execution_tag: params.executionTag,
          page: params.page,
          size: params.size,
        },
      },
    );

  return mapServerAgentExecutionToClientAgentExecution(response);
};

const mapServerAgentExecutionToClientAgentExecution = (
  agentExecution: ListAgentExecutionsApiV1AgentExecutionsGetApiResponse,
): PageAgentExecution => {
  return {
    items: agentExecution.items.map(mapServerAgentExecutionToAgentExecution),
    total: agentExecution.total ?? 0,
    page: agentExecution.page ?? 0,
    size: agentExecution.size ?? 0,
  };
};
